import React, { JSX } from "react";
import {
  IBeamIcon,
  HBeamIcon,
  LBeamIcon,
  HollowBeamIcon,
  TBeamIcon,
  UBeamIcon,
  VKRBeamIcon,
  ZBeamIcon,
  ConcreteCIcon,
  ConcreteFIcon,
  ConcreteKBIcon,
  ConcreteKBEIcon,
  ConcreteLIcon,
  ConcreteTIcon,
  ConcreteVTIcon,
  ConcreteRIcon,
  ConcretePLIcon,
  ConcreteVRIcon,
  HSQBeamIcon,
} from "@simplex/sx-icons";

// Usage example
// import GetIconForSection from './path-to-your-component';
// <GetIconForSection sectionName="CHS123" />
function renderIcon(propKey: string, iconSize: number): JSX.Element | null {
  const size = iconSize || 12;
  switch (propKey) {
    case "C":
      return <ConcreteCIcon size={size} />;
    case "Dressed":
      return <ConcreteRIcon size={size} />;
    case "F":
      return <ConcreteFIcon size={size} />;
    case "Glulam":
      return <ConcreteRIcon size={size} />;
    case "KB":
      return <ConcreteKBIcon size={size} />;
    case "KBE":
      return <ConcreteKBEIcon size={size} />;
    case "Kerto":
      return <ConcreteRIcon size={size} />;
    case "L":
      return <ConcreteLIcon size={size} />;
    case "R":
      return <ConcreteRIcon size={size} />;
    case "S":
      return <ConcreteRIcon size={size} />;
    case "PL":
      return <ConcretePLIcon size={size} />;
    case "VR":
      return <ConcreteVRIcon size={size} />;
    case "VT":
      return <ConcreteVTIcon size={size} />;
    case "CHS":
      return <HollowBeamIcon size={size} />;
    case "ASB":
    case "HEA":
    case "HEB":
    case "HEM":
    case "UC":
    case "UBP":
      return <HBeamIcon size={size} />;
    case "I":
    case "IPE":
    case "UB":
      return <IBeamIcon size={size} />;
    case "KCKR":
    case "VCKR":
      return <HollowBeamIcon size={size} />;
    case "LE":
    case "LU":
    case "EA":
    case "UA":
      return <LBeamIcon size={size} />;
    case "Sawn":
      return <ConcreteRIcon size={size} />;
    case "T":
    case "TPS":
      return <TBeamIcon size={size} />;
    case "U":
    case "UAP":
    case "UPE_SWE":
    case "UPE_DIN":
    case "UPE_NEN":
    case "PFC":
      return <UBeamIcon size={size} />;
    case "UKB":
      return <IBeamIcon size={size} />;
    case "UKC":
      return <HBeamIcon size={size} />;
    case "BOX":
    case "VKR":
    case "KKR":
      return <VKRBeamIcon size={size} />;
    case "Z":
      return <ZBeamIcon size={size} />;
    case "HSQ":
      return <HSQBeamIcon size={16} />; // custom size on this one because it's so thin
    default:
      return null; // Return null if no matching icon is found
  }
}

const caseKeys = [
  "C",
  "Dressed",
  "F",
  "Glulam",
  "KB",
  "KBE",
  "Kerto",
  "L",
  "R",
  "VR",
  "VT",
  "CHS",
  "ASB",
  "HEA",
  "HEB",
  "HEM",
  "HSQ",
  "UC",
  "UBP",
  "I",
  "IPE",
  "UB",
  "KCKR",
  "VCKR",
  "LE",
  "LU",
  "EA",
  "UA",
  "Sawn",
  "T",
  "TPS",
  "U",
  "UAP",
  "UPE_SWE",
  "UPE_DIN",
  "UPE_NEN",
  "PFC",
  "UKB",
  "UKC",
  "VKR",
  "KKR",
  "Z",
];

interface GetIconForSectionProps {
  sectionName: string;
  iconSize?: number;
}

const GetIconForSection: React.FC<GetIconForSectionProps> = ({ sectionName, iconSize = 12 }) => {
  if (sectionName) {
    // for (const key of caseKeys) {
    //   if (sectionName.startsWith(key)) {
    //     return renderIcon(key, iconSize);
    //   }
    return renderIcon(sectionName, iconSize);
  }
  return null;
};

export default GetIconForSection;
